import productsData from '../data/products.json';
import { db } from '../firebase/config';
import { doc, writeBatch } from 'firebase/firestore';

const PRODUCTS_COLLECTION = 'products';

/**
 * One-time import of the bundled products.json catalog into Firestore.
 * Safe to re-run — each product is written with its productId as the
 * document id, so re-importing overwrites rather than duplicates.
 */
export const migrateLocalProductsToFirestore = async () => {
    const allProducts = Object.values(productsData).flat();
    const batch = writeBatch(db);

    allProducts.forEach((product) => {
        const productRef = doc(db, PRODUCTS_COLLECTION, product.productId);
        batch.set(productRef, product, { merge: true });
    });

    await batch.commit();
    return allProducts.length;
};

export const getLocalProductCount = () =>
    Object.values(productsData).flat().length;
